// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"0eb8d9b8","404":"cb96f405","498":"5acd488e"}[chunkId] + ".chunk.js";
};